import Image from "next/image";
import Link from "next/link";
import Logo from "./../../public/images/cp_logo.webp";
import WhiteLogo from "./../../public/images/logo_flat.jpeg";
import { useRouter } from "next/router";
import {
  isChildrenPageActive,
} from "../../utils/daynamicNavigation";
import { useEffect, useState } from "react";
import WalletButton from "../wallet-btn/WalletButton";
import {useAuth} from "react-oidc-context";
import SiteConfig from "../../siteConfig";
import DarkMode from "../mode/DarkMode";

export default function HeaderAuthenticated() {
  const auth = useAuth();
  const [toggle, setToggle] = useState(false);

  // window resize
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        setToggle(false);
      }
    });
  });

  const signOutRedirect = () => {
    window.location.href = SiteConfig.COGNITO_LOGOUT_URI;
  };
  
  const handleLogout = () => {
    auth.removeUser().catch((error) => console.log(error));
    signOutRedirect();
  };

  const route = useRouter();
  
  return <>
    {/* main desktop menu sart*/}
    <header className="js-page-header fixed top-0 z-20 w-full backdrop-blur transition-colors">
      <div className="flex items-center px-6 py-6 xl:px-24 ">
        <Link className="shrink-0" href="/" >

          <div className="dark:hidden flex justify-center items-center">
            {<Image
                src={Logo}
                height={75}
                width={75}
                alt="CarbonPump | CADR Registry"
                className="h-auto"
            />}
          </div>
          <div className="hidden dark:block flex justify-center items-center">
            {<Image
                src={Logo}
                height={75}
                width={75}
                alt="CarbonPump | CADR Registry"
                className="h-auto"
            />}
          </div>

        </Link>
        {/* End  logo */}

        <div className="js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">
          <nav className="navbar w-full">
            <ul className="flex flex-col lg:flex-row">
              <li className="group" onClick={() => setToggle(false)}>
                <Link href="/">

                  <button
                      className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Home
                </span>
                  </button>

                </Link>
              </li>
              <li className="group" onClick={() => setToggle(false)}>
                <Link href="/collection/explore_collection">

                  <button
                      className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/collection/explore_collection", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Projects
                </span>
                  </button>

                </Link>
              </li>
              <li className="group" onClick={() => setToggle(false)}>
                <Link href="/activity">

                  <button
                      className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/activity", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Transactions
                </span>
                  </button>

                </Link>
              </li>
              <li className="group" onClick={() => setToggle(false)}>
                <Link href="/pledges">

                  <button
                      className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/pledges", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Pledges
                </span>
                  </button>

                </Link>
              </li>
              <li className="group">
                <Link href="/contact">

                  <button
                      className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                        className={
                          isChildrenPageActive(route.asPath, "/contact")
                              ? "text-accent dark:text-accent"
                              : ""
                        }
                    >
                      Contact Us
                    </span>
                  </button>

                </Link>
              </li>
            </ul>
          </nav>
          {/* End menu for desktop */}

          <div className="ml-8 hidden items-center lg:flex xl:ml-12">
            {/*  <WalletButton/>  */}
            {/* End metamask Wallet */}

            <div className="js-nav-dropdown group-dropdown relative">
              <button
                  className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                  className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                </svg>
              </button>
              <div className="dropdown-menu dark:bg-jacarta-800 group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-4 !top-[85%] !left-auto z-10 min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl hidden lg:invisible lg:opacity-0">
                <Link
                  href="/user/current"
                  className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                  >

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                  </svg>
                  <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                    My Profile
                  </span>

                </Link>
                <Link
                  href="#"
                  onClick={handleLogout}
                  className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                  >

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z" />
                  </svg>
                  <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                    Sign out
                  </span>

                </Link>
              </div>
            </div>
          </div>
          {/* End header right content (metamask and other) for desktop */}
        </div>
        {/* header menu conent end for desktop */}

        <div className="ml-auto flex lg:hidden">
          <Link
            href="/user/current"
            className="border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            aria-label="profile"
            >

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
            </svg>

          </Link>
          <button
            className="js-mobile-toggle border-jacarta-100 hover:bg-accent dark:hover:bg-accent focus:bg-accent group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            aria-label="open mobile menu"
            onClick={() => setToggle(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
            </svg>
          </button>
        </div>
        {/* End header right content  for mobile */}
      </div>
      {/* End flex item */}
    </header>
    {/* main desktop menu end */}

    {/* start mobile menu and it's other materials  */}
    <div
      className={`lg:hidden js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-20 ml-auto items-center bg-white lg:visible lg:relative lg:inset-auto lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent ${
        toggle ? "nav-menu--is-open" : "hidden"
      }`}
    >
      <div className="t-0 dark:bg-jacarta-800 fixed left-0 z-10 flex w-full items-center justify-between bg-white p-6 lg:hidden">
        <div className="dark:hidden">
          <Image
            src={Logo}
            height={75}
            width={75}
            alt="Xhibiter | CADR Marketplace"
            className="max-h-7 h-auto "
          />
        </div>

        <button
          className="js-mobile-close border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
          onClick={() => setToggle(false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={24}
            height={24}
            className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
          </svg>
        </button>
      </div>
      {/* mobile menu top header content */}

      <nav className="navbar w-full">
        <ul className="flex flex-col lg:flex-row pt-20">
          <li className="group" onClick={() => setToggle(false)}>
            <Link href="/">

              <button
                  className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Home
                </span>
              </button>

            </Link>
          </li>
          <li className="group" onClick={() => setToggle(false)}>
            <Link href="/collection/explore_collection">

              <button
                  className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/collection/explore_collection", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Projects
                </span>
              </button>

            </Link>
          </li>

          <li className="group" onClick={() => setToggle(false)}>
            <Link href="/activity">

              <button
                  className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/activity", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Transactions
                </span>
              </button>

            </Link>
          </li>
          <li className="group" onClick={() => setToggle(false)}>
            <Link href="/pledges">

              <button
                  className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/pledges", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Pledges
                </span>
              </button>

            </Link>
          </li>
          <li className="group" onClick={() => setToggle(false)}>
            <Link href="/contact">

              <button
                  className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                <span
                    className={
                      isChildrenPageActive("/contact", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                    }
                >
                  Contact Us
                </span>
              </button>

            </Link>
          </li>
          <li className="group" onClick={() => setToggle(false)}>
            <Link
                href="#"
                onClick={handleLogout}
                className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl py-2 transition-colors"
            >

              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z" />
              </svg>
              <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                    Sign out
                  </span>

            </Link>
          </li>
        </ul>

      </nav>
      {/* End navbar mobile menu  */}

    </div>
    {/* End mobile menu and it's other materials */}
  </>;
}
